module.exports = __webpack_public_path__ + "img/29.45b1f2c1.jpg";